import { get, set, keyBuilder } from '@/react/hooks/useLocalStorage';
import { isValidReturnUrl } from '@/portainer/helpers/url-utils';

const KEY = 'RETURN_URL';

export function storeReturnUrl(url: string): void {
  set(KEY, url);
}

/**
 * Reads `?returnUrl=` off the current page query string and stores it, so it
 * survives even when the login page never mounts (e.g. an already
 * authenticated visitor redirected away before `LoginView` renders).
 */
export function captureReturnUrlFromQuery(): void {
  const returnUrl = new URLSearchParams(window.location.search).get(
    'returnUrl'
  );
  if (returnUrl && isValidReturnUrl(returnUrl)) {
    storeReturnUrl(returnUrl);
  }
}

export function getReturnUrl(): string | null {
  return get<string | null>(KEY, null);
}

export function cleanReturnUrl(): void {
  localStorage.removeItem(keyBuilder(KEY));
}
